import { BRAND } from "../../config/brand";

export const DOWNLOADS_WA_LINK = `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent("Olá! Preciso de ajuda para instalar o app do MasterX HD.")}`;

export const INSTALL_STEPS = [
  { n: 1, title: "Permitir Fontes Desconhecidas", desc: "Vá em Configurações > Segurança > Ative 'Fontes Desconhecidas'." },
  { n: 2, title: "Baixar o APK", desc: "Clique no botão BAIXAR APK no topo desta página." },
  { n: 3, title: "Instalar", desc: "Abra o arquivo .apk baixado e toque em INSTALAR." },
  { n: 4, title: "Fazer Login", desc: "Abra o app e use o usuário/senha enviados pelo WhatsApp." },
];
